function makeDraggable(el) {
    if (!el) return;
    var isDragging = false, offsetX = 0, offsetY = 0;
    function onStart(e) {
        isDragging = true;
        var t = e.touches ? e.touches[0] : e;
        var r = el.getBoundingClientRect();
        offsetX = t.clientX - r.left;
        offsetY = t.clientY - r.top;
        el.style.transition = 'none';
    }
    function onMove(e) {
        if (!isDragging) return;
        var t = e.touches ? e.touches[0] : e;
        var maxX = window.innerWidth - el.offsetWidth;
        var maxY = window.innerHeight - el.offsetHeight;
        var posX = Math.min(Math.max(0, t.clientX - offsetX), maxX);
        var posY = Math.min(Math.max(0, t.clientY - offsetY), maxY);
        el.style.left = posX + 'px';
        el.style.top = posY + 'px';
        el.style.right = 'auto';
        el.style.bottom = 'auto';
    }
    function onEnd() { isDragging = false; }
    el.addEventListener('mousedown', onStart);
    el.addEventListener('touchstart', onStart);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', function (e) { if (e.touches.length === 1) onMove(e); });
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
    document.addEventListener('touchcancel', onEnd);
}

document.addEventListener('DOMContentLoaded', function () {
    makeDraggable(document.getElementById('floatImage'));
    makeDraggable(document.getElementById('fifaFloat'));
});
